<template>
  <v-container>
    <v-dialog v-model="dialogs.template" max-width="800">
      <obj-template
        v-if="dialogs.template"
        v-on:close="dialogs.template = false"
        :template="template"
        :newObj="template == null"
        :type="type"
        :isPredefined="false"
      ></obj-template>
    </v-dialog>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="subheading">
          Candidate Templates
          <v-spacer></v-spacer>
          <v-btn
            fab
            dark
            x-small
            class="mt-0"
            color="blue"
            @click="newTemplate('Candidate')"
          >
            <font-awesome-icon size="lg" icon="plus" />
          </v-btn>
        </v-subheader>
        <v-divider></v-divider>
        <v-alert
          v-if="candidateTemplateItems.length == 0"
          class="mt-2"
          text
          type="warning"
          outlined
          border="left"
          >No Templates</v-alert
        >
        <v-list subheader three-line>
          <v-list-item
            v-for="(item, index) in candidateTemplateItems"
            :key="index"
            @click="editTemplate(item)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.type }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="subheading">
          Client Templates
          <v-spacer></v-spacer>
          <v-btn
            fab
            dark
            x-small
            class="mt-0"
            color="blue"
            @click="newTemplate('Client')"
          >
            <font-awesome-icon size="lg" icon="plus" />
          </v-btn>
        </v-subheader>
        <v-divider></v-divider>
        <v-alert
          v-if="clientTemplateItems.length == 0"
          class="mt-2"
          text
          type="warning"
          outlined
          border="left"
          >No Templates</v-alert
        >
        <v-list subheader three-line>
          <v-list-item
            v-for="(item, index) in clientTemplateItems"
            :key="index"
            @click="editTemplate(item)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.type }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import objTemplate from '@/components/template';

export default {
  components: {
    objTemplate
  },
  data() {
    return {
      template: null,
      type: null,
      dialogs: {
        template: false
      }
    };
  },
  computed: {
    ...mapState({
      templates: state => state.templates
    }),
    candidateTemplateItems() {
      return this.templates.items.filter(template => {
        return !template.predefined && template.type == 'Candidate';
      });
    },
    clientTemplateItems() {
      return this.templates.items.filter(template => {
        return !template.predefined && template.type == 'Client';
      });
    }
  },
  methods: {
    ...mapActions({
      fetchTemplates: 'templates/fetch'
    }),
    newTemplate(type) {
      this.type = type;
      this.template = null;
      this.dialogs.template = true;
    },
    editTemplate(template) {
      this.template = { ...template };
      this.type = template.type;
      this.dialogs.template = true;
    }
  },
  mounted() {
    this.fetchTemplates();
  }
};
</script>
